/**
 * Vue event bus 用于非父子组件间的通信
 * 使用方法：
 * 1. 在需要发送事件的组件中引入 eventBus，然后使用 eventBus.$emit('eventName', data) 发送事件
 * 2. 在需要接收事件的组件中引入 eventBus，然后使用 eventBus.$on('eventName', (data) => { ... }) 监听事件
 * 事件说明：
 * - toPayByPassword: 输入支付密码后回调，参数为支付密码字符串
 * - showPwdOrEmailDialog: 显示支付密码或邮箱验证对话框，参数为 dialogType:string = 'setPwd / changePwd / forgetPwd / setEmail / showEmail' , data: { type: 'password' | 'email', info: any }
 */
import Vue from 'vue';
const eventBus = new Vue();
export default eventBus;
